import { getSkinId } from 'src/helpers/utils';
import HttpClient from './http';

const getCasinoTournamentInstances = (): Promise<any> => {
  return HttpClient.get(
    {
      path: '/casinoTournament/getCasinoTournamentInstances',
      baseURL: process.env.REACT_APP_GOS_API as string,
    },
    false,
    {
      skinId: getSkinId(),
      tournamentType: 'regular',
    }
  );
};

export { getCasinoTournamentInstances };
